import React, { useEffect, useState } from "react";
import map from "../../assets/image/map.svg";
import { useInView } from "react-intersection-observer";
import sanityClient from "../../client.js";

function Fpartfour() {
  const [allPostsData, setAllPosts] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "adress"]{
        title,
        body,
        slug
    }`,
      )
      .then((data) => setAllPosts(data))
      .catch(console.error);

    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  if (!loading) {
    return <div></div>;
  }
  return (
    <div ref={ref} className={`box ${inView ? "actives" : ""}`}>
      <div className="color1 w-20 h-20 inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-500 mb-5 flex-shrink-0">
        <a
          href="https://www.google.com/maps/place/Visseringlaan+19-23,+2288+ER+Rijswijk/@52.037953,4.3302383,17z/data=!3m1!4b1!4m6!3m5!1s0x47c5b68f5af76b1b:0xe9c65832e7c87682!8m2!3d52.0379497!4d4.3328132!16s%2Fg%2F11yjgrckx1?entry=ttu&g_ep=EgoyMDI2MDcwNi4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:invert"
        >
          <img className="mapme" src={map} width="70px" />
        </a>
      </div>
      <div className="flex-grow">
        {allPostsData &&
          allPostsData.map((adress, index) => (
            //<Link to={"/" + post.slug.current} key={post.slug.current}>
            <span key={index}>
              <h2 className="text-gray-900 text-lg title-font font-medium mb-3">
                {adress.title}
              </h2>

              <p className="leading-relaxed text-base">{adress.body}</p>
            </span>
            // </Link>
          ))}
      </div>
    </div>
  );
}
export default Fpartfour;
